/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "sort-c861f5dd--sprite",
  "use": "sort-c861f5dd--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"sort-c861f5dd--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(7.457 9.978)\"><g transform=\"translate(0 5.146)\"><g transform=\"translate(11.897 0.205)\"><path d=\"M261.562,198.984l4.595,4.595,4.595-4.595\" transform=\"translate(-261.562 -198.984)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" /></g><g transform=\"translate(9.19 4.595) rotate(180)\"><path d=\"M0,0,4.595,4.595,9.19,0\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" /></g></g><path d=\"M3014.112-16986.871v9.873\" transform=\"translate(-3009.557 16993.043)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2\" /><path d=\"M3014.112-16986.871v9.945\" transform=\"translate(-2997.623 16986.871)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
